module.exports = __webpack_public_path__ + "static/media/icon-experts@2x.c56426b0.png";